import { useState, useEffect } from 'react';
import useWS from '../../utils/ws';

export default (function (connect) {
  const { data, activeClose, sendMessage, connectionStatus } = useWS({
    url: 'ws/actual?uri=status',
    connect,
  });
  const [status, setStatus] = useState({});

  useEffect(() => {
    if (data) {
      let newStatus = JSON.parse(JSON.stringify(status));
      Object.keys(data.status).forEach(groupId => {
        if (!newStatus[data.id]) newStatus[data.id] = {};
        newStatus[data.id][groupId] = data.status[groupId];
      });

      setStatus(newStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [status, sendMessage, connectionStatus, activeClose];
});
